/* eslint-disable */
import axios from 'axios';

const apiChat = axios.create({
  baseURL: process.env.REACT_APP_API_CHAT,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
    //'Access-Control-Allow-Origin': '*',
  },
});

export default apiChat;
